<!-- 步骤条 -->
<template>
  <div class="step_box">
    <!-- 客户反馈 -->
    <el-steps direction="vertical" :active="activeIndex">
      <el-step :title="$t('workOrder.client_feedback')" @click.native="edit('1')">
        <div slot="description" class="desc_box">
          <p>{{$t('workOrder.client')}}：{{raw.client}}</p>
          <p>{{$t('workOrder.contact_details')}}：{{raw.contactDetails}}</p>
          <p>{{$t('workOrder.problem_desc')}}：{{descHandle(raw.step1)}}</p>
          <p class="time">{{$t('workOrder.creation_time')}}：{{raw.createTime | timeFormat}}</p>
        </div>
      </el-step>
      <!-- 售后分析 -->
      <el-step :title="$t('workOrder.after_sales')" @click.native="edit('2')">
        <div v-if="step2 != null" slot="description" class="desc_box">
          <p>{{$t('workOrder.return_date')}}：{{step2.returnTime, 'date' | timeFormat}}</p>
          <p>{{$t('workOrder.warranty_expired')}}：{{step2.isOut? $t('workOrder.yes'):$t('workOrder.no')}}</p>
          <p>{{$t('workOrder.suggest')}}：{{step2.description}}</p>
          <p>{{$t('workOrder.handler')}}：{{step2.name}}</p>
          <p class="time">{{$t('workOrder.processing_time')}}：{{step2.handleTime | timeFormat}}</p>
        </div>
      </el-step>
      <!-- 品质检查 -->
      <el-step :title="$t('workOrder.quality_inspection')" @click.native="edit('3')">
        <div v-if="step3 != null" slot="description" class="desc_box">
          <p>{{$t('workOrder.order_num')}}：{{step3.singleNumber}}</p>
          <p>{{$t('workOrder.whether_unpack')}}：{{step3.isUnpack?$t('workOrder.yes'):$t('workOrder.no')}}</p>

          <p>{{$t('workOrder.production_date')}}：{{step3.production_date, 'date' | timeFormat}}</p>
          <p>{{$t('workOrder.ship_date')}}：{{step3.ship_date, 'date' | timeFormat}}</p>

          <p>{{$t('workOrder.remark')}}：{{step3.description}}</p>
          <p>{{$t('workOrder.handler')}}：{{step3.name}}</p>
          <p class="time">{{$t('workOrder.processing_time')}}：{{step3.handleTime | timeFormat}}</p>
        </div>
      </el-step>
      <!-- 维修处理 -->
      <el-step :title="$t('workOrder.repair_processing')" @click.native="edit('4')">
        <div v-if="step4 != null" slot="description" class="desc_box">
          <p>{{$t('workOrder.cause_analysis')}}：{{step4.reason}}</p>
          <p>{{$t('workOrder.maintenance_scope')}}：{{step4.scope}}</p>
          <p>{{$t('workOrder.precautions')}}：{{step4.measure}}</p>
          <p>{{$t('workOrder.question_category')}}：{{problemTypeHandle(step4.problemType)}}</p>
          <p>{{$t('workOrder.remark')}}：{{step4.description}}</p>
          <p>{{$t('workOrder.handler')}}：{{step4.name}}</p>
          <p class="time">{{$t('workOrder.processing_time')}}：{{step4.handleTime | timeFormat}}</p>
        </div>
      </el-step>
      <!-- 生产线处理 -->
      <el-step :title="$t('workOrder.line_handling')" @click.native="edit('5')">
        <div v-if="step5 != null" slot="description" class="desc_box" >
          <p>{{$t('workOrder.finished_testing')}}：{{testStatus(step5.finishedTest)}}</p>
          <p>{{$t('workOrder.aging_test')}}：{{testStatus(step5.agingTest)}}</p>
          <p>{{$t('workOrder.recheck')}}：{{testStatus(step5.recheck)}}</p>
          <p>{{$t('workOrder.packaging_storage')}}：{{step5.isPack? $t('workOrder.yes'):$t('workOrder.no')}}</p>
          <p>{{$t('workOrder.remark')}}：{{step5.description}}</p>
          <p>{{$t('workOrder.handler')}}：{{step5.name}}</p>
          <p class="time">{{$t('workOrder.processing_time')}}：{{step5.handleTime | timeFormat}}</p>
        </div>
      </el-step>
      <!-- /PMC处理 -->
      <el-step :title="$t('workOrder.pmc_handling')" @click.native="edit('6')">
        <div v-if="step6 != null" slot="description" class="desc_box" >
          <p>{{$t('workOrder.inventory_date')}}：{{step6.warehousing, 'date' | timeFormat}}</p>
          <p>{{$t('workOrder.ship_date')}}：{{step6.shipping, 'date' | timeFormat}}</p>
          <p>{{$t('workOrder.remark')}}：{{step6.description}}</p>
          <p>{{$t('workOrder.handler')}}：{{step6.name}}</p>
          <p class="time">{{$t('workOrder.processing_time')}}：{{step6.handleTime | timeFormat}}</p>
        </div>
      </el-step>
      <!-- 完成 -->
      <el-step :title="raw.status == 101? $t('workOrder.scrapped'):$t('workOrder.finish')">
        <div slot="description" v-if="raw.status >= 100">
          <p v-if="raw.remark">{{$t('workOrder.remark')}}：{{raw.remark}}</p>
          <p class="time">{{$t('workOrder.processing_time')}}：{{raw.updateTime | timeFormat}}</p>
        </div>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import { problemTypes} from '../options'
export default {
  components: {},
  props: {
    raw: {}
  },
  data () {
    return {
      problemTypes
    };
  },
  computed: {
    step2 () {
      if (this.raw.step2) {
        return JSON.parse(this.raw.step2)
      }
      return null
    },
    step3 () {
      if (this.raw.step3) {
        return JSON.parse(this.raw.step3)
      }
      return null
    },
    step4 () {
      if (this.raw.step4) {
        return JSON.parse(this.raw.step4)
      }
      return null
    },
    step5 () {
      if (this.raw.step5) {
        return JSON.parse(this.raw.step5)
      }
      return null
    },
    step6 () {
      if (this.raw.step6) {
        return JSON.parse(this.raw.step6)
      }
      return null
    },
    activeIndex () {
      if (this.raw.status >= 100) return 7
      return this.raw.status - 1
    }
  },
  methods: {
    descHandle (str) {
      if (str) {
        return JSON.parse(str).description
      }
      return '--'
    },
    edit (current) {
      this.$emit('edit', current)
    },
    problemTypeHandle(val) {
      let name = ''
      this.problemTypes.forEach(element => {
        if (element.value == val) name = element.label
      });
      if (name) {
        return this.$t('workOrder.'+ name)
      }
      return '--'
    },
    testStatus (val) {
      if (val == 1) return this.$t('workOrder.not_performed')
      if (val == 2) return this.$t('workOrder.pass')
      if (val == 3) return this.$t('workOrder.fail')
      return '--'
    }
  }
}
</script>

<style lang='scss' scoped>
.step_box {
  padding: 20px;
}

.desc_box {
  cursor: pointer;
  p {
    font-size: 16px;
    margin: 4px 0;
    color: #333;
  }
  .contact {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .time {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>